import LegalBody from "./LegalBody";
import { PRIVACY_SECTIONS, PRIVACY_UPDATED } from "./legal_content";

export default function Privacy() {
  return (
    <LegalBody
      title="Gizlilik Politikası"
      updated={PRIVACY_UPDATED}
      sections={PRIVACY_SECTIONS}
    />
  );
}
